import { render, staticRenderFns } from "./SignupLinksPast.vue?vue&type=template&id=15127d60&scoped=true"
import script from "./SignupLinksPast.vue?vue&type=script&lang=js"
export * from "./SignupLinksPast.vue?vue&type=script&lang=js"
import style0 from "./SignupLinksPast.vue?vue&type=style&index=0&id=15127d60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15127d60",
  null
  
)

export default component.exports